import { OrganizationId } from "libs/organization";
import { ApiCollection, Collection, CollectionId } from "../model";

export function toCollection(apiCollection: ApiCollection): Collection {
  return {
    uuid: apiCollection.uuid as CollectionId,
    name: apiCollection.name,
    organization: apiCollection.organization as OrganizationId,
    embedModel: apiCollection.embed_model,
  };
}
